function initN20CleaningTabs() {
  if (window.innerWidth > 850) return;

  var wrapper = document.querySelector('.n20-cleaning-swiper');
  if (!wrapper) return;
  if (wrapper.querySelector('.n20-tab-bar')) return; // already initialized

  var swiperEl = wrapper.querySelector('.swiper-container.new-common-product-swiper-container');
  var slides = wrapper.querySelectorAll('.swiper-slide.featured-item');
  if (!swiperEl || !slides.length) return;

  // Create tab bar
  var bar = document.createElement('div');
  bar.className = 'n20-tab-bar';

  slides.forEach(function (s, i) {
    var t = s.querySelector('.title-box .big') || s.querySelector('.title-box');
    if (!t) return;
    var tab = document.createElement('div');
    tab.className = 'n20-tab' + (i === 0 ? ' active' : '');
    tab.textContent = t.textContent.trim();
    tab.dataset.index = i;
    tab.addEventListener('click', function () {
      var sw = swiperEl.swiper;
      if (sw) sw.slideTo(i);
    });
    bar.appendChild(tab);
  });

  // Insert tab bar inside the section
  var section = wrapper.querySelector('.new-common-product-swiper-section');
  if (section) {
    section.appendChild(bar);
  }

  // Sync tabs on slide change
  function syncTabs() {
    var sw = swiperEl.swiper;
    if (!sw) return;
    sw.on('slideChange', function () {
      var tabs = bar.querySelectorAll('.n20-tab');
      tabs.forEach(function (t) { t.classList.remove('active'); });
      if (tabs[sw.activeIndex]) tabs[sw.activeIndex].classList.add('active');
    });
  }

  // Wait for swiper to initialize
  var checkInterval = setInterval(function () {
    if (swiperEl.swiper) {
      clearInterval(checkInterval);
      syncTabs();
    }
  }, 100);
  setTimeout(function () { clearInterval(checkInterval); }, 5000);
}

function initN20TabbarSticky() {
  var tabbar = document.querySelector('.common-tabbar-outer-container.enable_sticky');
  if (!tabbar) return;
  var section = tabbar.closest('.shopify-section');
  var offset = section ? section.offsetTop + section.offsetHeight : tabbar.offsetTop + tabbar.offsetHeight;

  function onScroll() {
    if (window.scrollY > offset) {
      tabbar.classList.add('n20-fixed-tabbar');
      document.querySelector('.section-header').classList.add('z-index-1');
    } else {
      tabbar.classList.remove('n20-fixed-tabbar');
      document.querySelector('.section-header').classList.remove('z-index-1');
    }
  }

  window.addEventListener('scroll', onScroll);
  onScroll();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initN20CleaningTabs();
    initN20TabbarSticky();
  });
} else {
  initN20CleaningTabs();
  initN20TabbarSticky();
}
